import _ from 'lodash';
import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import EditImage from '../edit-image';

@inject('artistStore', 'userStore')
@observer
class PhotosHeader extends Component {
	@autobind
    handleImageCrop (cropResult) {
        const {artistStore, userStore} = this.props;
        const fromLogin = _.isFunction(userStore.getLoggedInUser);
		const user =  fromLogin ? userStore.getLoggedInUser() :userStore.items.find(i=>i._id === rowUserID._id);

		const artist = artistStore.loggedInArtist;
		artist.photoData = cropResult;
		
	}
	
	render () {
		const { artistStore, userStore } = this.props;
		const user = userStore.getLoggedInUser();

		const artist = artistStore.loggedInArtist;
		return (
			<div>
				<h3 className="subheader">Upload your PNG and JPG photos here</h3>
				<EditImage
					item={ artist }
					alwaysShowUpload
					store={ artistStore }
					handleImageCrop={ this.handleImageCrop } />
			</div>
		);
	}
}

export default PhotosHeader;
